import { render, staticRenderFns } from "./EmptyClassrooms.vue?vue&type=template&id=1de6cc68&scoped=true&"
import script from "./EmptyClassrooms.vue?vue&type=script&lang=js&"
export * from "./EmptyClassrooms.vue?vue&type=script&lang=js&"
import style0 from "./EmptyClassrooms.vue?vue&type=style&index=0&id=1de6cc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de6cc68",
  null
  
)

export default component.exports